// @flow
import env from '../../../environment';
import {getCreator, postCreator, putCreator} from '../../../http';

export const endpoints = Object.freeze({
  GET_REVIEWS: `${env.baseApiUrl}/winehouse/admin/order-review`,
  GET_AVERAGE: `${env.baseApiUrl}/im/admin/order/review/average`,
  GET_PENDING_REVIEWS: `${env.baseApiUrl}/im/admin/order`,
  EDIT_REVIEW: `${env.baseApiUrl}/im/admin/order/:orderId/review`,
  SEND_EMAIL: `${env.baseApiUrl}/im/admin/order/:orderId/review/send-email`,
});

export const getReviewsApi = getCreator(endpoints.GET_REVIEWS);
export const getReviewAverageApi = getCreator(endpoints.GET_AVERAGE);
export const getPendingReviewsApi = getCreator(endpoints.GET_PENDING_REVIEWS);
export const editReviewApi = putCreator(endpoints.EDIT_REVIEW);
export const sendEmailApi = postCreator(endpoints.SEND_EMAIL);
